<template>
  <section v-show="active" class="app-modal__section">
    <div class="app-modal__section-head">
      <h4>{{ text.modal.form.financial.title }}</h4>
      <p>{{ text.modal.form.financial.subtitle }}</p>
    </div>

    <div class="app-modal__grid two-columns">
      <label class="app-modal-field">
        <span>{{ text.modal.form.financial.fields.creditDays }}</span>
        <input v-model="form.creditDays" type="number" min="0" class="form-control" :placeholder="text.modal.form.financial.placeholders.creditDays" />
      </label>
      <!--AQUI IRIA CUENTA CONTABLE  -->
    </div>
  </section>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('customers');

export default {
  name: 'CustomerSectionFinancial',
  props: {
    active: { type: Boolean, default: false },
    form: { type: Object, required: true },
  },
  data() {
    return {
      text,
    };
  },
};
</script>
